import { useQuery } from "@tanstack/react-query";
import { useTacticHooks } from "../providers/TacticHooksProvider";
import { useAuthenticated } from "./authenticated/useAuthenticated";

export function useCalendarByResource(resourceId: string | null) {
  const { apiClient } = useTacticHooks();
  const {
    userContext: { authenticatedUser }
  } = useAuthenticated();
  // The legacy API only lets organization owners read a resource's calendar;
  // anyone else gets a 403, so don't ask.
  const canReadCalendars =
    !!authenticatedUser?.user?.permissions?.includes("calendar:read");
  const {
    data: calendar,
    error,
    isLoading
  } = useQuery({
    queryKey: ["integrations.calendar", resourceId],

    queryFn: async () => {
      const res = await apiClient.calendar.getCalendarByResourceId(
        resourceId as string
      );
      return res.result;
    },

    enabled: !!resourceId && canReadCalendars,

    meta: {
      shouldIgnoreGlobalErrorHandler: true
    }
  });
  return { calendar, isLoading, error };
}
